import React from 'react'
import styled from 'styled-components'
import { containerDefaultStyles } from 'styles/defaults'
import { Link } from 'gatsby'
import LogoIcon from 'images/header/magic-logo.svg'
import mediaQuery from 'styles/mediaQuery'
import colors from '../../../styles/colors'

const Section = styled.footer`
  padding: 45px 0;
  background-color: #18181c;

  ${mediaQuery.mobile} {
    padding-top: 10px;
  }
`

const SectionContainer = styled.div`
  ${containerDefaultStyles};

  ${mediaQuery.bigTabletMin} {
    display: flex;
  }

  & > * {
    min-width: 0;
  }
`

const LogoColumn = styled.div`
  flex: 0 0 220px;
  margin-bottom: 20px;
`

const LogoLink = styled(Link)`
  display: block;
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
`

const Logo = styled(LogoIcon)`
  width: 50px;
  height: 50px;
  margin-bottom: 40px;
`

const Description = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${colors.gray2};
`

const NavColumns = styled.div`
  & > * {
    min-width: 0;
  }

  ${mediaQuery.tablet} {
    flex-wrap: wrap;
    width: 100%;
  }

  ${mediaQuery.tabletMin} {
    display: flex;
  }

  ${mediaQuery.bigTabletMin} {
    justify-content: flex-end;
    flex: 1 0 auto;
  }
`

const NavColumn = styled.div`
  flex: 0 0 180px;

  &:last-child {
    flex: 0 0 230px;
  }

  ${mediaQuery.tabletMax} {
    margin-bottom: 30px;
  }
`

const NavTitle = styled.h6`
  font-weight: 600;
  font-size: 14px;
  line-height: 32px;
  color: #fff;
`

const NavLink = styled(Link)`
  display: block;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: ${colors.gray2};
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`

const Footer = () => (
  <Section>
    <SectionContainer>
      <LogoColumn>
        <LogoLink to="/" aria-label="Home">
          <Logo />
        </LogoLink>
        <Description>
          The do nothing e&#8209;commerce operating system.
        </Description>
      </LogoColumn>
      <NavColumns>
        <NavColumn>
          <NavTitle>About MagicOs</NavTitle>
          <NavLink to="/magic-os/#overview">Overview</NavLink>
          <NavLink to="/magic-os/#product">Product</NavLink>
          <NavLink to="/magic-os/#ecosystem">Ecosystem</NavLink>
          <NavLink to="/magic-os/#brands">Brands</NavLink>
          <NavLink to="/magic-os/#join">Join today</NavLink>
        </NavColumn>
        <NavColumn>
          <NavTitle>Ecosystem</NavTitle>
          <NavLink to="/ecosystem/">Overview</NavLink>
          <NavLink to="/ecosystem/#brands-products">Brands & products</NavLink>
          <NavLink to="/ecosystem/#community">Community</NavLink>
          <NavLink to="/ecosystem/#platform">The platform</NavLink>
        </NavColumn>
        <NavColumn>
          <NavTitle>The Product</NavTitle>
          <NavLink to="/product/#overview">Overview</NavLink>
          <NavLink to="/product/#dashboard">Sales dashboard</NavLink>
          <NavLink to="/product/#eventory-management">
            Inventory & PO management
          </NavLink>
          <NavLink to="/product/#analytics-tracking">
            Content analysis & tracking
          </NavLink>
          <NavLink to="/product/#gratis-management">Gratis management</NavLink>
          <NavLink to="/product/#orders">Orders, items & payment</NavLink>
          <NavLink to="/product/#performance">
            Performance ads management
          </NavLink>
        </NavColumn>
      </NavColumns>
    </SectionContainer>
  </Section>
)

export default Footer
